import { Checkbox } from "antd";

const TableSettingsItem = ({ column, onClick }) => {
  return<div className="table-settins-item" onClick={onClick}>
    <Checkbox checked={!column.hidden}/>
    <div>{column.title}{column.hint ? ` (${column.hint})` : ""}</div>
  </div>
}

export default TableSettingsItem;